import {GetStaticProps} from "next";
import {serverSideTranslations} from "next-i18next/serverSideTranslations";
import HeaderAppyShop, {getComponentStaticProps, HeaderProps} from "../../components/header/headerAppyShop";
import {appyShopConfig} from "../../config";
import React, {useEffect, useState} from "react";
import {useTranslation} from "next-i18next";
import {useRouter} from "next/router";
import styles from "./review.module.scss";
import FooterAppyShop from "../../components/footer/footerAppyShop";
import {Field, FieldArray, Form, Formik} from "formik";
import Loader from "../../components/loader/loader";
import {toast} from "react-toastify";
import * as yup from "yup";
import {getProductListToReview, sendProductReview} from "../../services/review-service";
import {ReviewProductList} from "../../interfaces/review-interface";
import {StarsPicker} from "../../components/review/starsPicker";
import Meta from "../../components/meta/meta";
import {config} from "../../config-merchant";
import Link from "next/link";
import 'react-toastify/dist/ReactToastify.css';

function Review(props: { headerProps: HeaderProps }) {

    const router = useRouter();
    const {t} = useTranslation('common');
    const {i18n} = useTranslation('common');
    const [isSubmitClicked, setSubmitClicked] = useState<boolean>(false);
    const [isLoading, setLoading] = useState<boolean>(false);
    const [isError, setError] = useState<boolean>();
    const [reviewRequest, setReviewRequest] = useState<ReviewProductList>();

    const handleSubmit = async (values) => {
        const body = {
            name: values.name,
            reviewList: values.reviewList.map(rev => {
                return {
                    productId: rev.productId,
                    review: rev.review,
                    score: rev.score
                }
            })
        }
        try {
            setLoading(true);
            await sendProductReview(i18n.language.toUpperCase(), router.query.token + "", body);
            setLoading(false);
            toast(t('REVIEW_SUCCESS_TOAST'), options);
            setTimeout(() => router.push("/home"), 200);
        } catch (e) {
            setLoading(false);
        }
    }

    const schema = yup.object({
        name: yup.string().min(2, t('REVIEW_ERROR_NAME')).required(t('REVIEW_ERROR_NAME')),
        reviewList: yup.array().of(yup.object().shape({
            productId: yup.number(),
            review: yup.string(),
            score: yup.number().min(1).max(5).required(t("REVIEW_ERROR_SCORE"))
        })).required()
    });

    const options = {
        autoClose: 4000,
        type: toast.TYPE.SUCCESS,
        position: toast.POSITION.TOP_CENTER,
    };

    useEffect(() => {
        if (router.isReady) {
            if (router.query.token !== undefined) {
                getProductListToReview(i18n.language.toUpperCase(), router.query.token + "")
                    .then(res => {
                        setReviewRequest(res.data);
                        setError(false);
                    })
                    .catch(err => {
                        setError(true);
                    })
            } else {
                setError(true);
            }
        }
    }, [router])

    return (
        <>
            <Meta
                title={t("REVIEW_PAGE_TITLE")}
                description={config.shopSlogan[i18n.language]}
                image={config.merchantDomain + config.defaultMetaImage}
                metaRobots={false}
            />
            <HeaderAppyShop headerProps={props.headerProps}/>
            <main className={styles["review"]}>
                {
                    isError && <div className={styles["review-error"]}>
                        <div className={styles["text"]}>
                            {t("REVIEW_TOKEN_INVALID")}
                        </div>
                        <Link href='/home'>
                            <button type="submit">
                                {t('REVIEW_TOKEN_INVALID_BUTTON')}
                            </button>
                        </Link>
                    </div>
                }
                {
                    !(router.isFallback || reviewRequest === undefined) ? (
                        <div className={styles["review-text"]}>
                            <h2>{t("REVIEW_TITLE")}</h2>
                            <h3>{t("REVIEW_SUBTITLE").replace("%NB%", reviewRequest.orderId + "")}</h3>
                            <div className={styles["review-form"]}>
                                <Formik
                                    initialValues={{
                                        name: '',
                                        reviewList: reviewRequest.productsToReview
                                    }}
                                    onSubmit={handleSubmit}
                                    validationSchema={schema}
                                >{({errors, values, setFieldValue}) => (
                                    <Form>
                                        {(isSubmitClicked && errors.name) &&
                                            <div className={styles['error-form']}>{errors.name}</div>}
                                        <Field name="name" type="text" placeholder={t('REVIEW_NAME_LABEL')}/>
                                        <FieldArray
                                            name="reviewList"
                                            render={arrayHelpers => (
                                                <div>
                                                    {values.reviewList && values.reviewList.length > 0 && (
                                                        values.reviewList.map((review, index) => (
                                                            <div key={review.productId}>
                                                                <div className={styles['review-title-item']}>
                                                                    <img
                                                                        height={50}
                                                                        src={review.image}
                                                                        alt={review.name}
                                                                    />
                                                                    <h4>{review.name}</h4>
                                                                    <p className={styles['rate-label']}>
                                                                        {t("REVIEW_PRODUCT_SCORE")}
                                                                    </p>
                                                                </div>
                                                                {(isSubmitClicked && values.reviewList && values.reviewList[index].score === undefined) &&
                                                                    <div className={styles['error-form']}>
                                                                        {t("REVIEW_ERROR_SCORE")}
                                                                    </div>}
                                                                <StarsPicker
                                                                    key={review.productId}
                                                                    customKey={review.productId}
                                                                    onScoreChange={(nb) => {
                                                                        setFieldValue(`reviewList.${index}.score`, nb);
                                                                    }}
                                                                />
                                                                <Field
                                                                    component={"textarea"}
                                                                    name={`reviewList.${index}.review`}
                                                                    type={"text"}
                                                                    placeholder={t("REVIEW_PRODUCT_PLACEHOLDER").replace("%PRODUCT%", review.name)}
                                                                />
                                                            </div>
                                                        ))
                                                    )}
                                                </div>
                                            )}
                                        />

                                        <div className={styles["loader-place"]}>{isLoading && <Loader/>}</div>
                                        <button
                                            type="submit"
                                            onClick={() => setSubmitClicked(true)}
                                            disabled={isLoading}
                                        >
                                            {t('CONTACT_SEND_MSG')}
                                        </button>
                                    </Form>)}
                                </Formik>
                            </div>
                        </div>
                    ) : (
                        <div>
                            {!isError && <Loader/>}
                        </div>
                    )
                }
            </main>
            <FooterAppyShop/>
        </>
    )

}

export const getStaticProps: GetStaticProps = async (props: { locale: string, params: { id: string } }) => {

    return {
        props: {
            ...await serverSideTranslations(props.locale, ['common']),
            headerProps: await getComponentStaticProps(props.locale),
        },
        revalidate: appyShopConfig.revalidateData
    };
}

export default Review;
